import VueWrapper from '@/components/core/Vue/vue.wrapper';
// import SiteSetupAreaBrowserComponent from '../../site-setup-area-browser/site-setup-area-browser.component';
// import SiteSetupHeaderComponent from '../../site-setup-header/site-setup-header.component';
// import SiteSetupButtonBarComponent from '../../site-setup-button-bar/site-setup-button-bar.component';
import ClientAppBarComponent from '@/components/vuetify/client-app-bar/client-app-bar.component';
import {CreateUserViewModel, JobModel} from '@/sdk';
import {ReportsApi} from '@/sdk/api-services';
import {JobApi} from '@/sdk/api-services/job.api';
import {RoleApi} from '@/sdk/api-services/role.api';
import {TeamApi} from '@/sdk/api-services/team.api';
import SiteSetupButtonBarComponent from '@/views/client/site-setup/site-setup-button-bar/site-setup-button-bar.component';
// import JobSetupMainComponent from '../job-setup-main/job-setup-main.component';
import {renderAsync} from 'docx-preview';
import {Component, Prop} from 'vue-property-decorator';

@Component({
    components: {
        ClientAppBarComponent,
        // JobSetupMainComponent,
        SiteSetupButtonBarComponent,
    },
})
export default class InspectionHistoryCompoent extends VueWrapper {
    public $refs!: {
        reportContainer: HTMLDivElement;
    };

    @Prop({
        type: String,
        required: true,
    })
    public equipmentId!: string;

    public team: any = [];
    public name: string = 'add-member-dialog';
    public teamApi: TeamApi = new TeamApi();
    public roleApi: any = new RoleApi();
    public jobApi: JobApi = new JobApi();
    public newMember: CreateUserViewModel = new CreateUserViewModel();
    public roles: Array<any> = [];
    public siteId: string = '';
    public inspections: JobModel[] = [];

    public hasReport: boolean = false;
    public isLoading: boolean = false;
    public errorMessage: string = '';

    public reportsApi: ReportsApi = new ReportsApi();
    private reportData: ArrayBuffer | null = null;

    public getRoles() {
        this.roleApi.getAll().subscribe((res: any) => {
            this.roles = res ?? [];
            // console.log('ROLES:');
            // console.log(this.roles);
            this.roles.sort((roleA, roleB) => (roleA.name > roleB.name ? 1 : -1));
        });
    }
    public created() {
        this.siteId = this.$route.params['siteId'];
    }
    public mounted() {
        // this.getRoles();
        this.getInspectionHistory();
    }

    public getInspectionHistory() {
        this.jobApi
            .getLocationJobsWithCompletedPercentage(this.equipmentId)
            .then(res => {
                this.inspections = res;
            })
            .catch(err => {})
            .finally(() => {});
    }

    public addNewMemberClick() {
        // this.newSite = new SiteModel();
        this.newMember = new CreateUserViewModel();
        this.CoreSrv.OpenModal(this.name);
    }

    public clearForm(id: string) {
        this.ConfirmSrv.open('Cancel Data Entry', 'You will lose all unsaved progress if you click Yes', {ConfirmText: 'Yes', CancelText: 'No'}).then(yes => {
            if (yes) {
                //close modal
                this.CoreSrv.CloseModal(this.name);
            }
            // this.sitesApi.deleteSite(id).subscribe(
            //     res => {
            //         if (res.Status) {
            //             this.AlertSrv.show('success', 'Site has been deleted successfully!');
            //             this.loadAllSites();
            //         }
            //     },
            //     err => {
            //         this.AlertSrv.show('error', 'Unable to delete site. Please try again later.');
            //     }
            // );
        });
    }

    public async loadAndRenderReport(inspectionId: string) {
        this.isLoading = true;
        this.errorMessage = '';
        this.hasReport = false;
        this.reportData = null;

        if (this.$refs.reportContainer) {
            this.$refs.reportContainer.innerHTML = '';
        }

        this.reportsApi
            .generateInspectionReport(this.siteId, this.equipmentId, inspectionId, false)
            .then(async res => {
                const arrayBuffer = res.data;
                this.reportData = arrayBuffer; // Store the report data for download

                await renderAsync(arrayBuffer, this.$refs.reportContainer, this.$refs.reportContainer, {
                    className: 'docx',
                    inWrapper: false,
                    hideWrapperOnPrint: true,
                    ignoreWidth: true,
                    ignoreHeight: true,
                    ignoreFonts: true,
                    breakPages: true,
                    ignoreLastRenderedPageBreak: true,
                    experimental: false,
                    trimXmlDeclaration: true,
                    useBase64URL: false,
                    renderChanges: false,
                    renderHeaders: true,
                    renderFooters: true,
                    renderFootnotes: true,
                    renderEndnotes: true,
                    renderComments: false,
                    renderAltChunks: true,
                    debug: false,
                });

                this.hasReport = true;
            })
            .catch(err => {
                this.AlertSrv.show('error', err.message ?? 'Unable to load report file.');
                this.errorMessage = 'Could not load the report preview. Please try again later.';
                this.hasReport = false; // Ensure hasReport is false on error
            })
            .finally(() => {
                this.isLoading = false;
                // BUG FIX: Removed 'this.hasReport = false' from here as it would always override the status.
            });
    }

    public downloadReport(inspectionId: string) {
        if (!this.reportData) {
            this.AlertSrv.show('warning', 'No report data available to download. Please generate a report first.');
            return;
        }

        // Create a Blob from the ArrayBuffer
        const blob = new Blob([this.reportData], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});

        // Create a temporary URL for the blob
        const url = window.URL.createObjectURL(blob);

        // Create a temporary anchor element and trigger the download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `report-site-${this.siteId}-equipment-${this.equipmentId}-inspection-${inspectionId}.docx`); // Set a dynamic filename
        document.body.appendChild(link);
        link.click();

        // Clean up by removing the element and revoking the URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
}
